import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';
import loading from '@ms/yammer-web-components/dist/navigation/NavigationSpinner';

const feedLoader = () => import(/* webpackChunkName: "4-page-feed" */ '../PageFeed');
const inboxLoader = () => import(/* webpackChunkName: "4-page-inbox" */ '../PageInbox');
const campaignsDashboardLoader = () =>
  import(/* webpackChunkName: "4-page-campaigns-dashboard" */ '../PageCampaignsDashboard');
const campaignsHubLoader = () => import(/* webpackChunkName: "4-page-campaigns-hub" */ '../PageCampaignsHub');
const groupLoader = () => import(/* webpackChunkName: "4-page-group" */ '../PageGroup');
const groupCampaignsLoader = () => import(/* webpackChunkName: "4-page-group-campaigns" */ '../PageGroupCampaigns');
const campaignLoader = () => import(/* webpackChunkName: "4-page-campaign" */ '../PageCampaign');
const storylineHomeLoader = () => import(/* webpackChunkName: "4-page-storyline-home" */ '../PageStorylineHome');
const groupInsightsLoader = () =>
  import(/* webpackChunkName: "4-page-group-insights" */ '@ms/yammer-web-components/dist/group/PageGroupInsights');
const threadLoader = () => import(/* webpackChunkName: "4-page-thread" */ '../PageThread');
const userLoader = () => import(/* webpackChunkName: "4-page-user" */ '../PageUser');
const pendingPostLoader = () => import(/* webpackChunkName: "4-page-drafts" */ '../PagePendingPosts');
const userInsightsLoader = () => import(/* webpackChunkName: "4-page-user-insights" */ '../PageUserInsights');
const topicLoader = () => import(/* webpackChunkName: "4-page-topic" */ '../PageTopic');
const unifiedTopicLoader = () => import(/* webpackChunkName: "4-page-unified-topic" */ '../PageUnifiedTopic');
const topicNetworkQuestionLoader = () =>
  import(/* webpackChunkName: "4-page-topic-networkquestion" */ '../PageTopicNetworkQuestion');
const topicNetworkQuestionBrowseLoader = () =>
  import(/* webpackChunkName: "4-page-topic-networkquestion-browse" */ '../PageTopicNetworkQuestionBrowse');
const usagePolicyLoader = () => import(/* webpackChunkName: "4-page-usagepolicy" */ '../PageUsagePolicy');
const searchLoader = () => import(/* webpackChunkName: "4-page-search" */ '../PageSearch');
const liveEventLoader = () => import(/* webpackChunkName: "4-page-liveevent" */ '../PageLiveEvent');
const delegationSettingsLoader = () =>
  import(/* webpackChunkName: "4-page-delegation-settings" */ '../PageDelegationSettingsLifecycle');
const discoverGroupsLoader = () => import(/* webpackChunkName: "4-page-discover-groups" */ '../PageDiscoverGroups');
const logoutLoader = () => import(/* webpackChunkName: "4-page-logout" */ '../PageLogout');
const leadersDirectoryLoader = () =>
  import(/* webpackChunkName: "4-page-leaders-directory" */ '../PageLeadersDirectory');
const leadersCuratedFeedLoader = () =>
  import(
    /* webpackChunkName: "4-page-leaders-curated-feed" */ '@ms/yammer-web-components/dist/leadersCuratedFeed/PageLeadersCuratedFeedMain'
  );
const leadershipCornerLoader = () =>
  import(/* webpackChunkName: "4-page-leadershipcorner" */ '../PageLeadershipCorner');
const leaderDashboardLoader = () =>
  import(
    /* webpackChunkName: "4-page-leader-dashboard" */ '@ms/yammer-web-components/dist/leaderDashboard/PageLeaderDashboard'
  );
const questionThreadLoader = () => import(/* webpackChunkName: "4-page-question-thread" */ '../PageQuestionThread');
const questionsLoader = () => import(/* webpackChunkName: "4-page-questions" */ '../PageQuestions');
const storylineAdminSettingsLoader = () =>
  import(/* webpackChunkName: "4-page-storyline-admin-settings" */ '../PageStorylineAdminSettingsLifecycle');
const storylineAdminAdvancedSettingsLoader = () =>
  import(
    /* webpackChunkName: "4-page-storyline-admin-settings-advanced" */ '../PageStorylineAdminAdvancedSettingsLifecycle'
  );
const insightsLeadersLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-leaders" */ '@ms/yammer-web-components/dist/insights/PageInsightsLeadersMain'
  );
const insightsQnALoader = () =>
  import(/* webpackChunkName: "4-page-insights-qna" */ '@ms/yammer-web-components/dist/insights/PageInsightsQnAMain');
const insightsCampaignLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-campaign" */ '@ms/yammer-web-components/dist/insights/PageInsightsCampaign'
  );
const insightsCampaignRouterLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-campaign-router" */ '@ms/yammer-web-components/dist/insights/PageInsightsCampaignRouter'
  );
const insightsNetworkLoader = () =>
  import(
    /* webpackChunkName: "4-page-insights-network" */ '@ms/yammer-web-components/dist/insights/PageInsightsNetwork'
  );
const insightsMainLoader = () =>
  import(/* webpackChunkName: "4-page-insights-main" */ '@ms/yammer-web-components/dist/insights/PageInsightsMain');
const legacyRouteConverterLoader = () =>
  import(
    /* webpackChunkName: "4-page-legacyrouteconverter" */ '@ms/yammer-web-components/dist/route/LegacyRouteConverter'
  );
const legacyRouterLoader = () =>
  import(/* webpackChunkName: "4-page-legacyrouter" */ '@ms/yammer-web-components/dist/route/LegacyRouter');
const storylineRouterLoader = () =>
  import(/* webpackChunkName: "4-page-storylinerouter" */ '@ms/yammer-web-components/dist/route/StorylineRouter');
const campaignRouterLoader = () =>
  import(/* webpackChunkName: "4-page-campaignrouter" */ '@ms/yammer-web-components/dist/route/CampaignRouter');
const userAchievementsLoader = () =>
  import(/* webpackChunkName: "4-page-user-achievements" */ '@ms/yammer-web-components/dist/user/PageUserAchievements');
const askMeAnythingLoader = () => import(/* webpackChunkName: "4-page-askmeanything" */ '../PageAskMeAnything');
const askMeAnythingCommunityEventsLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-community-events" */ '../PageAskMeAnythingCommunityEvents');
const askMeAnythingUserEventsLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-user-events" */ '../PageAskMeAnythingUserEvents');
const askMeAnythingLeadersEventsLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-leaders-events" */ '../PageAskMeAnythingLeadersEvents');
const askMeAnythingEventCreationLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-event-creation" */ '../PageAskMeAnythingEventCreation');
const askMeAnythingEventEditingLoader = () =>
  import(/* webpackChunkName: "4-page-askmeanything-event-editing" */ '../PageAskMeAnythingEventEditing');
const adminSettingsLoader = () => import(/* webpackChunkName: "4-page-admin-settings" */ '../PageAdminSettings');
const articleLoader = () => import(/* webpackChunkName: "4-page-article" */ '../PageArticle');
const articleFooter = () =>
  import(/* webpackChunkName: "4-page-article" */ '@ms/yammer-web-components/dist/articles/ArticleFooter');
const articleNewLoader = () => import(/* webpackChunkName: "4-page-article-publisher" */ '../PageArticleNew');
const articleEditLoader = () => import(/* webpackChunkName: "4-page-article-publisher" */ '../PageArticleEdit');
const mediaPostImmersiveViewLoader = () =>
  import(
    /* webpackChunkName: "4-page-media-post-immersive-view" */ '@ms/yammer-web-components/dist/mediaPost/PageMediaPostImmersiveView'
  );
const networkThemeThreads = () =>
  import(
    /* webpackChunkName: "4-page-network-theme-threads" */ '@ms/yammer-web-components/dist/copilot/PageNetworkThemeThreads'
  );
const curatedThreadListLoader = () =>
  import(/* webpackChunkName: "4-page-curated-threads" */ '../PageCuratedThreadList');

export const Feed = lazyLoadOnRender({ loader: feedLoader, loading });
export const Inbox = lazyLoadOnRender({ loader: inboxLoader, loading });
export const CampaignsHub = lazyLoadOnRender({ loader: campaignsHubLoader, loading });
export const CampaignsDashboard = lazyLoadOnRender({ loader: campaignsDashboardLoader, loading });
export const Group = lazyLoadOnRender({ loader: groupLoader, loading });
export const Campaign = lazyLoadOnRender({ loader: campaignLoader, loading });
export const StorylineHome = lazyLoadOnRender({ loader: storylineHomeLoader, loading });
export const GroupCampaigns = lazyLoadOnRender({ loader: groupCampaignsLoader, loading });
export const GroupInsights = lazyLoadOnRender({ loader: groupInsightsLoader, loading });
export const Thread = lazyLoadOnRender({ loader: threadLoader, loading });
export const User = lazyLoadOnRender({ loader: userLoader, loading });
export const PendingPosts = lazyLoadOnRender({ loader: pendingPostLoader, loading });
export const UserInsights = lazyLoadOnRender({ loader: userInsightsLoader, loading });
export const Topic = lazyLoadOnRender({ loader: topicLoader, loading });
export const TopicNetworkQuestion = lazyLoadOnRender({ loader: topicNetworkQuestionLoader, loading });
export const TopicNetworkQuestionBrowse = lazyLoadOnRender({ loader: topicNetworkQuestionBrowseLoader, loading });
export const UnifiedTopic = lazyLoadOnRender({ loader: unifiedTopicLoader, loading });
export const UsagePolicy = lazyLoadOnRender({ loader: usagePolicyLoader, loading });
export const Search = lazyLoadOnRender({ loader: searchLoader, loading });
export const LiveEvent = lazyLoadOnRender({ loader: liveEventLoader, loading });
export const DelegationSettings = lazyLoadOnRender({ loader: delegationSettingsLoader, loading });
export const StorylineAdminSettings = lazyLoadOnRender({ loader: storylineAdminSettingsLoader, loading });
export const StorylineAdminAdvancedSettings = lazyLoadOnRender({
  loader: storylineAdminAdvancedSettingsLoader,
  loading,
});
export const DiscoverGroups = lazyLoadOnRender({ loader: discoverGroupsLoader, loading });
export const Logout = lazyLoadOnRender({ loader: logoutLoader, loading });
export const LeadershipCorner = lazyLoadOnRender({ loader: leadershipCornerLoader, loading });
export const LeadersDirectory = lazyLoadOnRender({ loader: leadersDirectoryLoader, loading });
export const LeadersCuratedFeed = lazyLoadOnRender({ loader: leadersCuratedFeedLoader, loading });
export const LeaderDashboard = lazyLoadOnRender({ loader: leaderDashboardLoader, loading });
export const Questions = lazyLoadOnRender({ loader: questionsLoader, loading });
export const QuestionThread = lazyLoadOnRender({ loader: questionThreadLoader, loading });
export const InsightsLeaders = lazyLoadOnRender({ loader: insightsLeadersLoader, loading });
export const InsightsQnA = lazyLoadOnRender({ loader: insightsQnALoader, loading });
export const InsightsCampaign = lazyLoadOnRender({ loader: insightsCampaignLoader, loading });
export const InsightsCampaignRouter = lazyLoadOnRender({ loader: insightsCampaignRouterLoader, loading });
export const InsightsNetwork = lazyLoadOnRender({ loader: insightsNetworkLoader, loading });
export const InsightsMain = lazyLoadOnRender({ loader: insightsMainLoader, loading });
export const LegacyRouteConverter = lazyLoadOnRender({ loader: legacyRouteConverterLoader, loading });
export const LegacyRouter = lazyLoadOnRender({ loader: legacyRouterLoader, loading });
export const StorylineRouter = lazyLoadOnRender({ loader: storylineRouterLoader, loading });
export const CampaignRouter = lazyLoadOnRender({ loader: campaignRouterLoader, loading });
export const UserAchievements = lazyLoadOnRender({ loader: userAchievementsLoader, loading });
export const AskMeAnything = lazyLoadOnRender({ loader: askMeAnythingLoader, loading });
export const AskMeAnythingCommunityEvents = lazyLoadOnRender({ loader: askMeAnythingCommunityEventsLoader, loading });
export const AskMeAnythingUserEvents = lazyLoadOnRender({ loader: askMeAnythingUserEventsLoader, loading });
export const AskMeAnythingLeadersEvents = lazyLoadOnRender({ loader: askMeAnythingLeadersEventsLoader, loading });
export const AskMeAnythingEventCreation = lazyLoadOnRender({ loader: askMeAnythingEventCreationLoader, loading });
export const AskMeAnythingEventEditing = lazyLoadOnRender({ loader: askMeAnythingEventEditingLoader, loading });
export const AdminSettings = lazyLoadOnRender({ loader: adminSettingsLoader, loading });
export const Article = lazyLoadOnRender({ loader: articleLoader, loading });
export const ArticleFooter = lazyLoadOnRender({ loader: articleFooter, loading });
export const ArticleNew = lazyLoadOnRender({ loader: articleNewLoader, loading });
export const ArticleEdit = lazyLoadOnRender({ loader: articleEditLoader, loading });
export const MediaPostImmersiveView = lazyLoadOnRender({ loader: mediaPostImmersiveViewLoader, loading });
export const NetworkThemeThreads = lazyLoadOnRender({ loader: networkThemeThreads, loading });
export const CuratedThreadList = lazyLoadOnRender({ loader: curatedThreadListLoader, loading });
